<template>
	<div class="container p-0" id="ReportsOverview">
		<div v-if="page_loaded == 0" class="spinner">
			<i class="fas fa-spinner fa-spin fa-2x"></i>
		</div>
		<div v-else>
			<div class="page-header gold mt-4 mb-2">
        <back-btn position="relative" class="mr-auto"></back-btn>
        <h2 class="mb-0 flex-grow-1 text-center"><i class="fas fa-users"></i> Community Report</h2>
			</div>
			<div class="row m-3">
				<div class="col-md-5">
					<b-form-datepicker
						placeholder="Start Date"
						v-model="dates.start.selected"
						:min="dates.start.min"
						:max="dates.start.max"
					>
					</b-form-datepicker>
				</div>
				<div class="col-md-5">
					<b-form-datepicker
						placeholder="End Date"
						v-model="dates.end.selected"
						:min="dates.end.min"
						:max="dates.end.max"
					>
					</b-form-datepicker>
				</div>
				<div class="col-md-2">
					<b-button block variant="outline-primary" @click="date_refresh">
						Refresh <i class="fas fa-sync-alt"></i>
					</b-button>
				</div>
			</div>

			<div class="d-flex justify-content-between align-items-baseline pl-3 gold m-4">
				<h4>Weekly Averages</h4>

				<router-link :to="`/profile_report/${profile.id}`" class="btn btn-sm btn-outline-primary">
					<i class="fas fa-user"></i>
					<span class="pl-1">My Report</span>
				</router-link>


			</div>

			<div v-if="cards !== null && Object.keys(cards).length > 0">
				<div v-for="(card, k) in cards" :key="k" class="card mb-3 small">
					<div class="card-header">
						<div class="row">
							<div class="col-9 col-sm-10 col-lg-11 text-left">
								<small>Weekly data for</small>
								<b v-text="card.range" class="pl-1"></b>
							</div>
						</div>
					</div>
					<div class="row p-3 text-left">

						<!-- Section 1: Meditation -->
						<div class="col-md-6 stats_wrapper">
							<h5>Meditation</h5>

							<table v-if="card.meditation" class="table table-sm">
								<thead>
									<tr class="small">
										<th scope="col" width="65%">Activity</th>
										<th scope="col" class="text-right">Community</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Sessions meditating</td>
										<td v-text="card.meditation.sessions_comm_avg || 0" class="community"></td>
									</tr>
									<tr>
										<td>Total time meditating <small>(h:m)</small></td>
										<td v-text="card.meditation.time_comm_avg || '00:00'" class="community"></td>
									</tr>
									<tr>
										<td>Avg. meditation time <small>(m)</small></td>
										<td v-text="card.meditation.time_m_comm_avg || 0" class="community"></td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- Section 2: Contractions -->
						<div class="col-md-6 stats_wrapper">
							<h5>Contractions</h5>

							<table v-if="card.contractions" class="table table-sm">
								<thead>
									<tr class="small">
										<th scope="col" width="65%">Activity</th>
										<th scope="col" class="text-right">Community</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Contractions logged</td>
										<td v-text="card.contractions.logged_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>Contractions processed</td>
										<td v-text="card.contractions.processed_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>Processing completion rate <small>%</small></td>
										<td v-text="card.contractions.completion_rate_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>Supporting others</td>
										<td v-text="card.contractions.connections_comm_avg" class="community"></td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>
				</div>
			</div>
			<div v-else class="text-center text-muted mt-5">
				<p>Start logging contractions and meditating to see your progress here.</p>
			</div>

		</div>
	</div>
</template>

<script>
import axios from 'axios';
import BackBtn from "@/components/BackBtn.vue";

export default {
	name: 'ReportsOverview',
  components: {BackBtn},

	data() {
		const today = new Date().toISOString().slice(0, 10);
		let date = new Date();
		let month = new Date().getMonth();
		const startDate = new Date(date.setMonth(month - 3)).toISOString().slice(0, 10);

		return {
			cards: null,

			dates: {
				end: {
					min: null,
					max: today,
					selected: today,
				},
				start: {
					min: null,
					max: today,
					selected: startDate,
				},
			},
			page_loaded: 0,
		}
	},

	methods: {
		date_refresh() {
			this.loadPageData();
		},

		loadPageData() {
			this.page_loaded = 0;
			this.profile_report_load();
			this.page_loaded = 1;
		},

		profile_report_load() {
			const params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('start_date', this.dates.start.selected);
			params.append('end_date', this.dates.end.selected);

			axios({
				url: this.$store.state.api_url + 'profileReport',
				params,
			})
				.then((response) => {
					this.cards = response.data.data;
				})
				.catch(function (error) {
					console.log(error);
				});
		}
	},

	mounted() {
		this.loadPageData();
	},
	computed: {
		profile() {
			return this.$store.state.profile;
		}
	},
}
</script>

<style scoped>

.page-header {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	gap: 14px;
  position: relative;
}


.spinner {
	text-align: center;
	margin: 2rem;
	color: #ccc;
}

.stats_wrapper {
	padding: 1rem;
	padding-top: 0;
	text-align: left;
}

.stats_wrapper .user {
	font-size: 0.9rem;
	color: #d1af60 !important;
	text-align: left;
	font-weight: bold;
}

.stats_wrapper .community {
	font-size: 0.8rem;
	color: #646464 !important;
	text-align: right;
}
</style>
